import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import RegionPanel from './RegionPanel';
import { Typography } from '@material-ui/core';
import CudaPaper from 'common/components/CudaPaper'
import { AzureLogoIcon } from 'common/components/icons'
import { ReloadIcon } from 'common/components/icons';
import Button from '@material-ui/core/Button';

const styles = {
    root: {
        width: '100%',
    },
    lbIconWrapper: {
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderColor: 'lightgray',
        padding: '5px',
        borderRadius: '10px',
        margin: '10px',
    },
    shadow: {
        webkitFilter: 'drop-shadow( 1px 2px 3px rgba(0, 0, 0, .7))',
        filter: 'drop-shadow( 1px 2px 3px rgba(0, 0, 0, .7))',
        /* Similar syntax to box-shadow */
    },
    cwafAccordion: {
        boxShadow: 'none',
        margin: 0
    },
    cwafAccordionSummaryContent: {
        margin: '0px',
        minHeight: '25px'
    },
    cwafAccordionExpanded: {
        height: 'auto',
        margin: 0,
        minHeight: 0
    },
    cwafAccordionDetails: {

    },

    cwafExpansionSummaryExpanded: {
        margin: '0 !important'
    },
    cwafExpansionSummary: {
        minHeight: '0 !important'
    },
    cwafExpansionIcon: {
        left: '-8px',
        top: '13px',
        right: 'auto'
    },
    button: {
        border: "none",
        backgroundColor: "white",
        color: "#0088CF",
        'a&:visited': {
            color: "#0088CF"
        },
        cursor: 'pointer',
    },
    typography: {
        display: "inline-block"
    },
    expandCollapseContainer:{
        paddingRight:'20px',
    },
    title: {
        padding: '13px 13px 5px 0px',
    }
};

class Regions extends React.Component {
    // componentDidUpdate(prevProps, prevState, snapshot){
    //     // this.props.setShouldUpdate('');
    // }
    
    render() {
        const {
            classes,
            isLoading,
            regions,
            regionsPanels,
            expandAll,
            toggleRegionPanel,
            collapseAll,
            regionsErrors,
            regionsAppCount,
            setShouldUpdate,
            shouldUpdate,
            reload,
        } = this.props
        return <CudaPaper loading={isLoading} >
            <Grid container item xs={12}>
                <Grid item container xs={6} className={classes.title} alignItems="flex-end">
                    <AzureLogoIcon />
                    <Button onClick={reload}>
                        <ReloadIcon />
                    </Button>
                </Grid>
                <Grid container item direction="row-reverse" alignItems="flex-end" xs={6}>
                    <Grid item className={classes.expandCollapseContainer}>
                        <button onClick={() => expandAll()} className={classes.button}
                        ><Typography variant='caption' color="primary" className={classes.typography}>Expand All</Typography></button> | {" "}
                        <button onClick={() => collapseAll()} className={classes.button}
                        ><Typography variant='caption' color="primary" className={classes.typography}>Collapse All</Typography></button>
                    </Grid>
                    <Grid item>

                    </Grid>
                </Grid>

            {Object.keys(regions).sort((a,b) => (regionsErrors[a] === regionsErrors[b] ? 0 
                : regionsErrors[a] === 'NORMAL' && regionsErrors[b] !== 'NORMAL' ? 1 
                : regionsErrors[a] !== 'NORMAL' && regionsErrors[b] === 'NORMAL' ? -1 
                : 0)).map((r, rIndex) =>
                <Grid item xs={12} key={`rp#${rIndex}`}>
                    <RegionPanel regionName={r}
                        regionData={regions[r]}
                        regionPanels={regionsPanels[r].values}
                        regionStatus={regionsErrors[r]}
                        expanded={regionsPanels[r].expanded}
                        togglePanel={toggleRegionPanel}
                        regionAppCount={regionsAppCount[r]}
                        shouldUpdate={shouldUpdate === r || shouldUpdate === 'all'}
                        setShouldUpdate={setShouldUpdate}>
                    </RegionPanel>
                </Grid>
            )}
        </Grid>
    </CudaPaper>
    }
};

export default withStyles(styles)(Regions);
